<li c-node='node' tree-type="treeType" ng-repeat='node in sort(tree)'></li>